import { useState } from "react";
import { ImageGernerationSimpleInputProps } from "../types/imageSimple/imageGeneration";
import { getImagePixelSize } from "../utils/images/imageConvertFormats";
import { ImageCreateProps } from "../types/ai/api";
import { ApiPayment } from "../apis/ApiPayment";

export const useUpdateImageGenerationCosts = (): [
    creationCosts: number | null,
    updateCosts: (inputs: ImageGernerationSimpleInputProps) => Promise<void>
] => {
    const [creationCosts, setCreationCosts] = useState<number|null>(0);
    const updateCosts = async(inputs: ImageGernerationSimpleInputProps) => {
        const imageDimension = getImagePixelSize(inputs.aspectRatio, inputs.quality);
        try{
            let dataObject: ImageCreateProps = {
                imgWidth: imageDimension.width,
                imgHeight: imageDimension.height,
                numberOfGenerations: inputs.numberOgGeneration,
                samplingSteps: inputs.samplingSteps,
                cfg: inputs.cfg,
                sampler: inputs.sampler,
                scheduler: inputs.scheduler,
                model:'Qwen',
                reference:  inputs.reference
            }
            await ApiPayment.GetCostsForImageCreate(dataObject)
            .then((response)=>{
                console.log(response);
                setCreationCosts(response.costs);
            })
            .catch(()=>{
                console.log('Error in calculation creation costs.');
            });
        }
        catch{
            console.log('Error in calculation creation costs.');
        }
    };

    return [creationCosts, updateCosts];
};